/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import prestashop from 'prestashop';
import $ from 'jquery';

var $body = $('body');

$body.on(
    'click',
    '[data-button-action="add-to-cart-seq"]',
    (event) => {
        event.preventDefault();
        const selector = $(event.currentTarget);
        const elSeqQty = selector.parent().prev();
        let url;
        let is_box;
        if ($('#add-to-cart-or-refresh').length > 0) {
            // page propduit
            url = $('.product-add-to-cart').siblings('input[name="url-shop"]').val();
            is_box = $('.product-add-to-cart').siblings('input[name="is-box"]').val();
        } else {
            // miniature
            url = selector.parent().siblings('input[name="url-shop"]').val();
            is_box = selector.parent().siblings('input[name="is-box"]').val();
        }
        // l'ajout au panier concerne une box : on va tester si la date de livraison convient à offcourses
        if (is_box === "1") {
            $.ajax({
                url: url + 'module/seq_magasins/ajax',
                type: 'GET',
                cache: false,
                data: {
                    ajax: true,
                    action: 'checkBox',
                },
                success: function (message) {
                    const messageFormat = JSON.parse(message);
                    if (messageFormat.success) {
                        elSeqQty.removeAttr('hidden');
                        selector.attr('hidden', true);
                        elSeqQty.find('.qty-seq').text("1");
                        addToCart(event);
                        prestashop.emit('updateProduct', {
                            reason: event.currentTarget.dataset,
                            event: event
                        });
                    } else {
                        alert(messageFormat.message);
                    }
                }
            });
        } else {
            elSeqQty.removeAttr('hidden');
            selector.attr('hidden', true);
            elSeqQty.find('.qty-seq').text("1");
            addToCart(event);
        }
    });

prestashop.blockcart = prestashop.blockcart || {};

prestashop.blockcart.showModal = (html) => {
    function getBlockCartModal() {
        return $('#blockcart-modal');
    }

    let $blockCartModal = getBlockCartModal();
    if ($blockCartModal.length) {
        $blockCartModal.remove();
    }

    $('body').append(html);
    $blockCartModal = getBlockCartModal();
    // $blockCartModal.modal('show').on('hidden.bs.modal', (event) => {
    //     prestashop.emit('updateProduct', {
    //         reason: event.currentTarget.dataset,
    //         event: event
    //     });
    // });

};

function addToCart(event) {
    if ($('#quantity_wanted').val() > $('[data-stock]').data('stock') && $('[data-allow-oosp]').data('allow-oosp').length === 0) {
        $('[data-button-action="add-to-cart-seq"]').attr('disabled', 'disabled');
    } else {
        let $form = $(event.target).closest('form');
        let query = $form.serialize() + '&add=1&action=update';
        let actionURL = $form.attr('action');

        let isQuantityInputValid = ($input) => {
            var validInput = true;

            $input.each((index, input) => {
                let $input = $(input);
                let minimalValue = parseInt($input.attr('min'), 10);
                if (minimalValue && $input.val() < minimalValue) {
                    onInvalidQuantity($input);
                    validInput = false;
                }
            });

            return validInput;
        };

        let onInvalidQuantity = ($input) => {
            $input.parents('.product-add-to-cart').first().find('.product-minimal-quantity').addClass('error');
            $input.parent().find('label').addClass('error');
        };

        let $quantityInput = $form.find('input[min]');
        if (!isQuantityInputValid($quantityInput)) {
            onInvalidQuantity($quantityInput);

            return;
        }

        $.post(actionURL, query, null, 'json').then((resp) => {
            prestashop.emit('updateCart', {
                reason: {
                    idProduct: resp.id_product,
                    idProductAttribute: resp.id_product_attribute,
                    idCustomization: resp.id_customization,
                    linkAction: 'add-to-cart',
                    cart: resp.cart
                },
                resp: resp
            });
        }).fail((resp) => {
            prestashop.emit('handleError', {eventType: 'addProductToCart', resp: resp});
        });
    }
}

$('.add-to-cart-seq .increaseQty').on('click', function (e) {
    e.preventDefault();
    updateProductQuantity($(this), "up");
});

$('.product-add-to-cart-seq .increaseQty').on('click', function (e) {
    e.preventDefault();
    updateProductPageQuantity($(this), "up");
});

$('.product-add-to-cart-seq .decreaseQty').on('click', function (e) {
    e.preventDefault();
    const elSeqQty = parseInt($(this).siblings('.qty-seq').text());
    if (elSeqQty === 1) {
        //delete product from cart
        $(this).parent().attr('hidden', true);
        $(this).parent().next().find('button[type="submit"]').removeAttr('hidden');
        const url = $(this).parent().parent().find('input[name=url]').val();
        const idProduct = $(this).parent().parent().find('input[name=id_product]').val();
        const params = [];
        params.push({
            name: 'id_product',
            value: idProduct
        }, {
            name: 'delete',
            value: 1
        });
        $.ajax({
            url: url,
            type: "POST",
            data: params,
            success: function () {
                const quantityCartEl = $('.cart-products-count');
                const newQuantity = parseInt(quantityCartEl.text()) - 1;
                quantityCartEl.text(newQuantity);
            },
        });
    } else {
        updateProductPageQuantity($(this), "down");
    }
});

$('.add-to-cart-seq .decreaseQty').on('click', function (e) {
    e.preventDefault();
    const elSeqQty = parseInt($(this).siblings('.qty-seq').text());

    if (elSeqQty === 1) {
        //delete product from cart
        $(this).parent().attr('hidden', true);
        $(this).parent().next().find('button[type="submit"]').removeAttr('hidden');

        const form = $(this).parent().parent();
        const actionUrl = form.attr('action');
        let params = form.serializeArray();
        params.push({
            name: 'delete',
            value: 1
        });
        $.ajax({
            url: actionUrl,
            type: "POST",
            data: params,
            success: function () {
                const quantityCartEl = $('.cart-products-count');
                const newQuantity = parseInt(quantityCartEl.text()) - 1;
                quantityCartEl.text(newQuantity);
            },
        });
    } else {
        updateProductQuantity($(this), "down");
    }
});

// $('.add-to-cart-seq button[type="submit"]').on('click', function (e) {
//     e.preventDefault();
//     const elSeqQty = $(this).parent().prev();
//     console.log(elSeqQty);
//     elSeqQty.removeAttr('hidden');
//     $(this).attr('hidden', true);
//     elSeqQty.find('.qty-seq').text("1");
// });

$('.product-add-to-cart-seq button[type="submit"]').on('click', function (e) {
    e.preventDefault();
    const elSeqQty = $(this).parent().prev();
    elSeqQty.removeAttr('hidden');
    $(this).attr('hidden', true);
    elSeqQty.find('.qty-seq').text("1");
});

function updateProductPageQuantity(thisEl, op) {
    const elSeqQty = thisEl.siblings('.qty-seq');
    const url = thisEl.parent().parent().find('input[name=url]').val();
    const idProduct = thisEl.parent().parent().find('input[name=id_product]').val();
    const params = [];
    params.push({
        name: 'id_product',
        value: idProduct
    }, {
        name: 'update',
        value: 1
    }, {
        name: 'action',
        value: 'update'
    }, {
        name: 'op',
        value: op
    });
    $.ajax({
        url: url,
        type: "POST",
        data: params,
        dataType: 'json',
        success: function (retour) {
            prestashop.emit('updateCart', {
                reason: {
                    idProduct: retour.id_product,
                    idProductAttribute: retour.id_product_attribute,
                    idCustomization: retour.id_customization,
                    linkAction: 'add-to-cart',
                    cart: retour.cart
                },
                resp: retour
            });
            elSeqQty.text(parseInt(retour.quantity));
        }
    });
}

function updateProductQuantity(thisEl, op) {
    const elSeqQty = thisEl.siblings('.qty-seq');
    const form = thisEl.parent().parent();
    const actionUrl = form.attr('action');
    let params = form.serializeArray();
    params.push({
        name: 'update',
        value: 1
    }, {
        name: 'action',
        value: 'update'
    }, {
        name: 'op',
        value: op
    });
    $.ajax({
        url: actionUrl,
        type: "POST",
        data: params,
        dataType: 'json',
        success: function (retour) {
            prestashop.emit('updateCart', {
                reason: {
                    idProduct: retour.id_product,
                    idProductAttribute: retour.id_product_attribute,
                    idCustomization: retour.id_customization,
                    linkAction: 'add-to-cart',
                    cart: retour.cart
                },
                resp: retour
            });
            elSeqQty.text(parseInt(retour.quantity));
        }
    });
}


// WEBPACK FOOTER //
// ./js/components/block-cart.js